import { Logger } from '@frontend/logger';
import { useAppSelector } from '@frontend/common';
import { IoTClient } from '@frontend/iot/api';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { navigationStore } from './redux/terminal-navigation-slice';

export const useHeartbeat = () => {
    const navigationState = useAppSelector(useSelector, navigationStore);

    useEffect(() => {
        const interval = setInterval(() => {
            if (navigationState.iot == null) return Logger.warn('Could not send heartbeat, iot is null');
            return IoTClient.postHeartbeat(navigationState.iot.account_id, navigationState.iot.id)
                .then(() => Logger.debug('Heartbeat sent successfully.'))
                .catch(() => Logger.warn('Failed to send a heartbeat to the server.'));
        }, 60 * 1000);

        return () => clearInterval(interval);
    }, []);
};
